var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgCrops(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24 23.2v-2h.4a3.204 3.204 0 003.2-3.2.4.4 0 00-.4-.4h-.8a3.2 3.2 0 00-2.8 1.654 3.2 3.2 0 00-2.8-1.654H20a.4.4 0 00-.4.4 3.204 3.204 0 003.2 3.2h.4v2h-6.8v-9.366h.4a3.204 3.204 0 003.2-3.2.4.4 0 00-.4-.4h-.8c-.417 0-.83.081-1.215.24.01-.08.015-.16.015-.24 0-1.29-1.305-2.28-1.36-2.32a.4.4 0 00-.48 0c-.056.04-1.36 1.03-1.36 2.32 0 .08.005.16.015.24a3.179 3.179 0 00-1.215-.24h-.8a.4.4 0 00-.4.4 3.204 3.204 0 003.2 3.2h.4v1.21a1.98 1.98 0 00-1.2-.41h-.8a.4.4 0 00-.4.4 2.002 2.002 0 002 2h.4V23.2H8.8v-2h.4a3.204 3.204 0 003.2-3.2.4.4 0 00-.4-.4h-.8a3.2 3.2 0 00-2.8 1.654A3.2 3.2 0 005.6 17.6h-.8a.4.4 0 00-.4.4 3.204 3.204 0 003.2 3.2H8v2H4v.8h24v-.8h-4zm2.4-4.8h.367a2.404 2.404 0 01-2.367 2h-.367a2.404 2.404 0 012.367-2zm-3.6 2a2.404 2.404 0 01-2.367-2h.367c1.17.002 2.17.846 2.367 2H22.8zm-7.6-4.166c-.508 0-.962-.32-1.132-.8h.332c.508 0 .962.32 1.132.8H15.2zm3.967-5.2a2.404 2.404 0 01-2.367 2h-.367a2.404 2.404 0 012.367-2h.367zM16 8.764c.442.371.728.897.8 1.47-.07.574-.356 1.1-.8 1.47a2.293 2.293 0 01-.8-1.47c.07-.574.356-1.1.8-1.47zm-.8 4.27a2.404 2.404 0 01-2.367-2h.367c1.17.002 2.17.846 2.367 2H15.2zm-4 5.366h.367a2.404 2.404 0 01-2.367 2h-.367a2.404 2.404 0 012.367-2zm-3.6 2a2.404 2.404 0 01-2.367-2H5.6c1.17.002 2.17.846 2.367 2H7.6z"
  }));
}

export default SvgCrops;